var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadPowerswitch = function SvgFadPowerswitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118 40.5 5-5h9.5c-1 0 4.5 5.5 4.5 5.5v81.5l-5.5 4.5H123l-5-4.5v-82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.887 58.547s-.476 4.792-1.43 6.23c-20.973 13.42-33.367 35.466-34.32 63.264 1.43 41.218 34.32 74.288 74.837 74.288 40.518 0 73.408-33.07 72.932-75.246.476-25.881-13.347-48.886-32.891-62.306-1.43-2.875-2.383-5.751-2.383-5.751l5.243-8.148s1.907-1.917 5.243-1.438c26.218 17.254 43.378 46.01 43.378 78.601 0 50.804-41.47 92.021-91.998 92.021-50.528 0-92.475-41.217-91.998-92.02 0-33.07 17.637-61.827 42.9-79.56 2.86-1.917 5.72 3.355 5.72 3.355l4.767 6.71z"
  }))));
};
export { SvgFadPowerswitch as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-powerswitch.928b7d75.svg";